import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { makeSelectFilterActive, makeSelectSpecialFilterContent } from '../selectors';
import { setSpecialFilterDataArray, setSpecialFilterId } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import initialStateConstants from '../initialStateConstants';

export const SpecialPreFilter = ({ specialItems, onSetSpecialFilterId, onSetSpecialFilterDataArray }) => {
  const appHistory = useHistory();
  const { search } = useLocation();
  const [queryParams, setQueryParams] = useState(queryString.parse(search)?.special ?? '');

  /**
   * @implements useEffect()
   *
   * Checks if filter should be run once (new) filterable items
   * become available.
   */
  useEffect(() => {
    if (queryParams.length > 0) {
      preFilter(queryParams);
    }
  }, [specialItems]);

  /**
   * @implements useEffect()
   *
   * Checks if a query parameter for this filter has changed and
   * kicks-off updates.
   */
  useEffect(() => {
    let newQueryString = queryString.parse(search)?.special ?? '';
    if (newQueryString === queryParams) {
      return null;
    }
    if (appHistory.action === 'POP') {
      preFilter(newQueryString);
    }
    setQueryParams(newQueryString);
  }, [search]);

  const preFilter = (updatedQueryString) => {
    if (specialItems.length === 0) {
      return null;
    }
    let filterItems = [];
    if (updatedQueryString.length > 0) {
      filterItems = updatedQueryString.split('_');
    }
    if (filterItems.length > 0) {
      onSetSpecialFilterId(filterItems);
      const specialStrings = filterItems.map((currentItem) => {
        const result = specialItems.find((item) => Object.keys(item)[0] === currentItem);
        if(!result) {
          resetFilter();
          return;
        }
        return result[Object.keys(result)].name;
      });
      onSetSpecialFilterDataArray(specialStrings);
    } else {
      resetFilter();
    }
  };

  const resetFilter = () => {
    onSetSpecialFilterId(initialStateConstants.specialFilterId);
    onSetSpecialFilterDataArray(initialStateConstants.specialFilterDataArray);
  };

  return <></>;
};

SpecialPreFilter.propTypes = {
  specialItems: PropTypes.array,
  onSetSpecialFilterId: PropTypes.func,
  onSetSpecialFilterDataArray: PropTypes.func,
  filterActive: PropTypes.number,
};

SpecialPreFilter.defaultProps = {
  specialItems: [],
  onSetSpecialFilterId: () => {},
  onSetSpecialFilterDataArray: () => {},
  filterActive: 0,
};

const mapStateToProps = createStructuredSelector({
  specialItems: makeSelectSpecialFilterContent(),
  filterActive: makeSelectFilterActive(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetSpecialFilterId: (value) => dispatch(setSpecialFilterId(value)),
    onSetSpecialFilterDataArray: (value) => dispatch(setSpecialFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(SpecialPreFilter);
